import Button from '../../../components/common/Button'

const WelcomeStep = ({ onNext }) => {
  return (
    <div className="text-center animate-fade-in">
      <div className="mb-6">
        <div className="flex justify-center mb-4">
          <span className="material-icons text-blue-500 text-6xl">
            verified_user
          </span>
        </div>
        <h1 className="text-3xl font-bold text-gray-900 dark:text-white mb-3">
          Bem-vindo!
        </h1>
        <p className="text-gray-600 dark:text-gray-400 text-lg">
          Para começar a usar a plataforma, você precisa ativar sua empresa.
        </p>
      </div>

      <div className="bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800 rounded-lg p-4 mb-8 text-left">
        <h3 className="font-semibold text-gray-900 dark:text-white mb-3">O que você precisa para ativar:</h3>
        <ul className="space-y-2 text-gray-700 dark:text-gray-300 text-sm">
          <li className="flex items-start gap-2">
            <span className="material-icons text-blue-500 flex-shrink-0">check_circle</span>
            <span><strong>ID da Empresa:</strong> Fornecido pela administração</span>
          </li>
          <li className="flex items-start gap-2">
            <span className="material-icons text-blue-500 flex-shrink-0">check_circle</span>
            <span><strong>Token de API:</strong> Token gerado no painel administrativo</span>
          </li>
          <li className="flex items-start gap-2">
            <span className="material-icons text-blue-500 flex-shrink-0">check_circle</span>
            <span><strong>Email válido:</strong> Para seu usuário administrador</span>
          </li>
        </ul>
      </div>

      <Button variant="primary" size="lg" onClick={onNext} className="w-full">
        <span className="material-icons text-sm">arrow_forward</span>
        Começar Ativação
      </Button>
    </div>
  )
}

export default WelcomeStep
